import script from "./TokenTransactions.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenTransactions.vue?vue&type=script&setup=true&lang=js"

import "./TokenTransactions.vue?vue&type=style&index=0&id=84d9f824&lang=css"

const __exports__ = script;

export default __exports__